import { render, staticRenderFns } from "./CardRenderCorpBoxComponent.vue?vue&type=template&id=1536a46a&"
import script from "./CardRenderCorpBoxComponent.vue?vue&type=script&lang=ts&"
export * from "./CardRenderCorpBoxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports